function changeTab(event) {
  console.log("tab change");
  //   console.log(event.target.classList);
  let index = event.target.classList.length - 1;

  // remove active from both
  document.querySelector(".tab-1").classList.remove("active");
  document.querySelector(".tab-2").classList.remove("active");
  // add the active class
  event.target.classList.add("active");
  console.log(event.target.getAttribute("id"));
  // get all the sliders
  let slidersList = document.querySelectorAll("slider-component");
  if (event.target.classList.contains("tab-1")) {
    // active slider-1
    document.getElementById("slider-1").style.display = "block";
    slidersList[1].parentElement.style.display = "none";
  } else {
    //activate the other slider
    // second one from
    document.getElementById("slider-1").style.display = "none";
    document.getElementById("slider-1").style.paddingBottom = "0";
    slidersList[1].parentElement.style.display = "block";
    slidersList[1].parentElement.style.paddingTop = "0";
  }
}
